import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px', color: '#e5e5e5', fontFamily: 'sans-serif' }}>
      
      <div style={{ marginBottom: '40px' }}>
        <Link to="/" style={{ 
          display: 'inline-flex', 
          alignItems: 'center', 
          gap: '8px', 
          color: '#a0a0a0', 
          textDecoration: 'none', 
          fontSize: '0.9rem',
          fontWeight: 'bold',
          padding: '8px 16px',
          backgroundColor: '#1a1a1a',
          borderRadius: '8px',
          border: '1px solid #333',
          transition: 'all 0.2s ease-in-out'
        }}
        onMouseOver={(e) => { e.currentTarget.style.color = '#ef4444'; e.currentTarget.style.borderColor = '#ef4444'; }}
        onMouseOut={(e) => { e.currentTarget.style.color = '#a0a0a0'; e.currentTarget.style.borderColor = '#333'; }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          Back to peekit.
        </Link>
      </div>

      <h1>Terms of Service for peekit.</h1>
      <p style={{ color: '#a0a0a0' }}>Last Updated: April 2026</p>

      <h3>1. Acceptance of Terms</h3>
      <p>By accessing peekitapp.com and using our services, you agree to be bound by these Terms. If you do not agree, do not use the service.</p>

      <h3>2. Account & Steam Integration</h3>
      <p>User accounts are created via Steam OpenID. You are responsible for maintaining the security of your Steam account. We are not liable for any loss resulting from unauthorized access to your account.</p>

      <h3>3. Prohibited Conduct & Fraud</h3>
      <p>You agree not to use cheats, automation software (bots), hacks, or any third-party software designed to modify the service or its statistics. Any attempt to manipulate the ranking system, skin economy, or financial transactions is strictly prohibited.</p>

      <h3>4. Legal Consequences of Fraud</h3>
      <p><strong>ATTENTION:</strong> peekit. takes fraud and financial theft extremely seriously. Any attempt to defraud the system, especially regarding virtual items (skins) or monetary transactions, will result in an immediate permanent ban. <strong>We reserve the right to pursue civil and criminal legal action against any user involved in fraudulent activities to the fullest extent permitted by law.</strong></p>

      <h3>5. Termination</h3>
      <p>We reserve the right to terminate or suspend your account at any time, without prior notice, for conduct that we believe violates these Terms.</p>

      <h3>6. Limitation of Liability</h3>
      <p>The service is provided "as is". peekit. shall not be liable for any indirect, incidental, or consequential damages resulting from the use of our platform.</p>
    </div>
  );
};

export default Terms;